import { render, staticRenderFns } from "./RegulatoryThresholds.vue?vue&type=template&id=542d022b"
import script from "./RegulatoryThresholds.vue?vue&type=script&lang=js"
export * from "./RegulatoryThresholds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports